export interface LayoutSidebarSchema {
  isSidebarOpen: boolean;
}

export const initialState: LayoutSidebarSchema = {
  isSidebarOpen: false,
};

